import { C3AssemblyCompletedSession } from './c3-assembly-task.model';

export enum C3ReportType {
  InventoryThreshold = 'InventoryThreshold',
  AssemblySession = 'AssemblySession',
}

export interface C3Report<TPayload = unknown> {
  id: string;
  type: C3ReportType;
  title: string;
  reportDate: string;
  sourceId: string;
  createdOn: Date;
  createdById: string;
  payload: TPayload;
}

export enum C3AssemblyInventoryPostingStatus {
  Posted = 'Posted',
  Reversed = 'Reversed',
}

export interface C3AssemblyReportInventory {
  status: C3AssemblyInventoryPostingStatus;
  postingGroupId: string;
  postedOn: Date;
  reversalGroupId: string;
  reversedOn: Date | null;
  reversalReason: string;
}

export interface C3AssemblyReportMetrics {
  included: boolean;
  excludedOn: Date | null;
  exclusionReason: string;
}

export interface C3AssemblyReportPayload {
  payloadVersion: 1;
  session: C3AssemblyCompletedSession;
  inventory: C3AssemblyReportInventory;
  metrics: C3AssemblyReportMetrics;
}

export type C3AssemblyReport = C3Report<C3AssemblyReportPayload> & {
  type: C3ReportType.AssemblySession;
};

export function isC3AssemblyReport(
  report: C3Report
): report is C3AssemblyReport {
  const payload = report.payload;
  return (
    report.type === C3ReportType.AssemblySession &&
    typeof payload === 'object' &&
    payload !== null &&
    'session' in payload &&
    'inventory' in payload &&
    'metrics' in payload
  );
}
